export default errorValue => {
    if(errorValue.constructor === Error) {
        return String(errorValue);
    } else if(errorValue.constructor === Array) {
        //return `${errorValue[0]}`;
        return String(errorValue[0]);
    }
    return String(errorValue);
};